import { motion } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import CloseIcon from "../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import NavbarV3 from "../../../components/NavbarV3/NavbarV3.tsx";
import SemAutorizacao from "../../../components/SemAutorizacao/SemAutorizacao";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import CoresRedux from "../../../contexts/Cor";
import NomeTabelaRedux from "../../../contexts/NomeTabela";
import RequestControllerRedux from "../../../contexts/RequestController";
import TabelaRedux from "../../../contexts/Tabela";
import DadosUsuarioRedux from "../../../contexts/Usuario";
import { getRegras } from "../../../services/ModuloGerenciador/Geral.ts";
import { verificaDadosUsuarioRedux } from "../../../services/ModuloGerenciador/Usuario";
import {
	cadastraTipoRastreamento,
	deleteTipoRastreamentoPorId,
	editaTipoRastreamentoPorId,
	getTipoRastreamento,
	getTipoRastreamentoPorId,
} from "../../../services/ModuloRastreamento/TipoRastreamento";
import "./TipoRastreamento.css";

function TipoRastreamento(props) {
	const { dadosCoresRedux } = useContext(CoresRedux);

	const { dadosUsuarioRedux, setDadosUsuarioRedux } =
		useContext(DadosUsuarioRedux);

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { dadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [errors, setErrors] = useState([]);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState([]);

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const buscarTipoRastreamento = async () => {
		setLoading(true);
		await getTipoRastreamento(dadosUsuarioRedux.token)
			.then((result) => {
				setDadosTabela(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Tipo Rastreamento";
		if (telaCadastro) return "Cadastro de Tipo Rastreamento";
		return "Tipo Rastreamento";
	}, [editando, telaCadastro]);

	const cadastrar = async (botaoCadastrarValidacao) => {
		setLoading(true);
		await cadastraTipoRastreamento(values, dadosUsuarioRedux.token)
			.then((result) => {
				if (result.status === 200) {
					buscarTipoRastreamento();
					setDadosRequestControllerRedux("Fechar Modal TipoRastreamento");
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
					setValues({});

					if (!botaoCadastrarValidacao) {
						setTelaCadastro(false);
					}
				}
			})
			.catch((error) => {
				const errorData = error.response.data;
				const newErrors = errorData.reduce((acc, curr) => {
					curr.memberNames.forEach((name) => {
						acc[name] = curr.errorMessage;
					});
					return acc;
				}, {});

				setErrors(newErrors);
				setTextoErro("Há campos obrigatórios a preencher!");
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const editar = async () => {
		setLoading(true);
		await editaTipoRastreamentoPorId(values, dadosUsuarioRedux.token)
			.then((result) => {
				if (result.status === 200) {
					buscarTipoRastreamento();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
					setTelaCadastro(false);
					setEditando(false);
					setValues({});
				}
			})
			.catch((error) => {
				const errorData = error.response.data;
				const newErrors = errorData.reduce((acc, curr) => {
					curr.memberNames.forEach((name) => {
						acc[name] = curr.errorMessage;
					});
					return acc;
				}, {});

				setErrors(newErrors);
				setTextoErro("Há campos obrigatórios a preencher!");
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const buscarTipoRastreamentoPorId = async () => {
		setLoading(true);
		await getTipoRastreamentoPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarTipoRastreamentoPorIdModal = async (id) => {
		setLoading(true);
		await getTipoRastreamentoPorId(id, dadosUsuarioRedux.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarTipoRastreamentoPorId = async () => {
		setLoading(true);
		await deleteTipoRastreamentoPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarTipoRastreamento();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
		setValues((current) => ({
			...current,
			usuario: dadosUsuarioRedux.usuario.usuario,
		}));
		setValidator((current) => ({ ...current, nome: "false" }));
	}, [loading]);

	useEffect(() => {
		if (editando) {
			buscarTipoRastreamentoPorId();
		}
	}, [editando]);

	useEffect(() => {
		buscarTipoRastreamento();
		if (props.idAtual) {
			buscarTipoRastreamentoPorIdModal(props.idAtual);
		}
	}, []);

	useEffect(() => {
		if (!!props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(true);

	useEffect(() => {
		if (dadosUsuarioRedux.regras !== undefined) {
			dadosUsuarioRedux.regras.forEach((element) => {
				if (element === "Configurações de Rastreamento") {
					setSemAutorizacao(false);
				}
			});
		} else {
			verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
			getRegras(
				dadosUsuarioRedux.token,
				dadosUsuarioRedux.usuario.idUsuario
			).then((result) => {
				let regras = [];
				result.data.forEach((dado) => {
					regras.push(dado.regras.regra);
					if (dado.regras.regra === "Configurações de Rastreamento") {
						setSemAutorizacao(false);
					}
				});
				dadosUsuarioRedux.regras = regras;
				setDadosUsuarioRedux(dadosUsuarioRedux);
			});
		}
	});

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					{props.navbar ? (
						<></>
					) : (
						<NavbarV3 title={title} selecionado="Tipo Rastreio" />
					)}
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					{props.navbar ? (
						<></>
					) : (
						<NavbarV3 title={title} selecionado="Tipo Rastreio" />
					)}
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							{!telaCadastro ? (
								<div className="embarques">
									<TabelaV2
										setTelaCadastro={setTelaCadastro}
										setEditando={setEditando}
										classeSelecionado="idTipoRastreamento"
										nomeClasse1="outer-wrapper-cidade"
										nomeClasse2="table-wrapper-cidade-v2"
										colunas={dadosTabelaRedux.TipoRastreamento}
										dados={dadosTabela}
									/>
									<div className="container-botoes-cliente">
										<div>
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Cadastrar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setTelaCadastro(true);
													setEditando(false);
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-editar"
												classText="button-texto-editar"
												titulo="Editar"
												icone="iconeEdit"
												cor="#CDCDCD"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setTelaCadastro(true);
														setEditando(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-deletar"
												classText="button-texto-cadastrar"
												titulo="Deletar"
												icone="iconeDelete"
												cor="#DC2D2D"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setOpen(true);
														setTextoSucesso("Deletado Com Sucesso");
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
										<div>
											<CustomButtonV2
												classCss="custom-button-user"
												classText="button-texto-user"
												titulo="Obter Usuário"
												cor="#FFFFFF"
												valor={values}
												onClick={() => {
													if (tabelaRedux.usuarioAlteracao) {
														setOpenUsuario(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
									</div>
								</div>
							) : (
								<div>
									{!props.desabilitar ? (
										<div className="indicadores">
											{props.botaoFechar !== false && (
												<div style={{ width: 29, height: 29 }} />
											)}
											<div className="texto-cadastro">
												<p className="indicador-emb">
													{"Dados de Tipo Rastreamento /"}
												</p>
												{editando ? (
													<p className="indicador-emb">
														{"Detalhes de Tipo Rastreamento"}
													</p>
												) : (
													<p className="indicador-emb">
														{"Cadastro de Tipo Rastreamento"}
													</p>
												)}
												<HeaderCadastro texto="" />
											</div>
											{props.botaoFechar !== false && (
												<div className="close-btn">
													<CloseIcon
														onClick={() => {
															setValues({});
															setTelaCadastro(false);
															setEditando(false);
															setTabelaRedux({});
															setErrors([]);
														}}
													/>
												</div>
											)}
										</div>
									) : (
										<></>
									)}
									<div className="flex-column">
										<div className="container-select-emb">
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															Nome:
														</p>
														<input
															type="text"
															style={{ width: "265px" }}
															className={`${
																errors.Nome ? "validacao-erro" : "input-emb"
															}`}
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	nome: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	nome: "true",
																}));
																if (errors.Nome) {
																	setErrors((current) => ({
																		...current,
																		Nome: null,
																	}));
																}
															}}
															placeholder="Ex: Onixsat"
															value={values.nome}
															disabled={props.desabilitar}
														/>
														{errors.Nome && (
															<div className="error-text">{errors.Nome}</div>
														)}
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															IP:
														</p>
														<input
															type="text"
															style={{ width: "265px" }}
															className={`${
																errors.Ip ? "validacao-erro" : "input-emb"
															}`}
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	ip: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	ip: "true",
																}));
																if (errors.Ip) {
																	setErrors((current) => ({
																		...current,
																		Ip: null,
																	}));
																}
															}}
															placeholder="Ex: 111.222.3.4"
															value={values.ip}
															disabled={props.desabilitar}
														/>
														{errors.Ip && (
															<div className="error-text">{errors.Ip}</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="botoes-embalagem">
										{editando ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													editar();
												}}
											/>
										) : (
											<>
												{!props.desabilitar ? (
													props.botaoCadastrar ? (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Salvar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																cadastrar(props.botaoCadastrar);
															}}
														/>
													) : (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Salvar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																cadastrar(props.botaoCadastrar);
															}}
														/>
													)
												) : (
													<></>
												)}
											</>
										)}
										{props.botaoVoltar ? (
											<></>
										) : (
											<CustomButtonV2
												classCss="custom-button-cancelar"
												classText="button-texto-cancelar"
												titulo="Cancelar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setValues({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
													setErrors([]);
												}}
											/>
										)}
									</div>
								</div>
							)}
							<div>
								<ModalConfirmacao
									titulo="Deletar"
									texto="Deseja Deletar?"
									tituloConfirmar="Confirmar"
									tituloCancelar="Cancelar"
									open={open}
									onClose={handleClose}
									onClick={deletarTipoRastreamentoPorId}
								/>
								<ModalUsuario
									titulo="Usuário"
									tituloConfirmar="OK"
									open={openUsuario}
									onClose={handleCloseUsuario}
								/>
							</div>
							<div>
								<ToastSucesso
									texto={textoSucesso}
									open={openToastSucesso}
									onClose={handleCloseToastSucesso}
								/>
								<ToastErro
									texto={textoErro}
									open={openToastErro}
									onClose={handleCloseToastErro}
								/>
							</div>
						</motion.div>
					) : (
						<LoadingComponent />
					)}
				</div>
			)}
		</motion.div>
	);
}

export default TipoRastreamento;
